import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './slideshow.css';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';

export class Slideshow {
	private instances: Array<{
		swiper: Swiper,
	}> = [];

	public constructor(
					private readonly slideshowSelector: string
	) {
		this.init();
	}

	private init(): void {
		document.querySelectorAll<HTMLElement>(this.slideshowSelector).forEach(slideshow => {
			const pagination = slideshow.querySelector<HTMLElement>('.swiper-pagination');

			const swiper = new Swiper(slideshow, {
				modules: [Navigation, Pagination, Autoplay],
				slidesPerView: 1,
				//spaceBetween: 0,
				keyboard: {
					enabled: true,
				},
				pagination: {
					el: pagination,
					clickable: true,
				},
				navigation: {
					nextEl: slideshow.querySelector<HTMLElement>('.gallery-swiper-button-next'),
					prevEl: slideshow.querySelector<HTMLElement>('.gallery-swiper-button-previous'),
				},
				loop: true,
				autoplay: {
					delay: 5000,
				},
				preventClicks: true,
			});

			this.instances.push({
				swiper
			});
		});
	}

	private tearDown(): void {
		for (const {swiper} of this.instances) {
			swiper.destroy();
		}

		this.instances = [];
	}
}

export let slideshow: Slideshow | undefined;
document.addEventListener('DOMContentLoaded', () => {
	slideshow = new Slideshow('.slideshow');
});
